import contract from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import check from './check.js'
import hideRegistrar from './hideRegistrar.js'

export default contract({
  check: array([
    check
  ]),
  hideRegistrar: array([
    hideRegistrar
  ])
})
